import { Box } from "@mui/material";
import { FOBPoTabs } from "../FOBPurchaseOrder.js";
import AllPoTab from "./AllPoTab/AllPoTab.js";
import CreatePoTab from "./CreatePoTab/CreatePoTab.js";
import FOBReport from "../ReportTab/FOBReport.js";

const RenderTabs = ({ selectedTab, setSelectedTab }) => {
	const tabs = [
		{
			...FOBPoTabs.create_po,
			component: <CreatePoTab />,
		},
		{
			...FOBPoTabs.all_po,
			component: <AllPoTab />,
		},
		{
			...FOBPoTabs.report,
			component: <FOBReport />,
		},
	];

	return (
		<Box display="flex" height="100%" width="100%">
			{tabs &&
				tabs.map((row) => {
					return (
						<Box height="100%" width="100%" p={1} key={row.key} display={row.key === selectedTab ? "block" : "none"}>
							{row.key === selectedTab && row.component}
						</Box>
					);
				})}
		</Box>
	);
};

export default RenderTabs;
